import React from "react";
import { Marker, InfoWindow } from "react-google-maps";
 import downloadVideoIcon from "../map/downloadVideo.png";
 import earningAchivementIcon from "../map/earning_achievement.png";
 import recieveSharedVidIcon from "../map/receive_shared_video.png";
 import shareAppBluetoothIcon from "../map/share_app_bluetooth.png";
 import sahreAppThroughOtherIcon from "../map/share_app_through_other.png";
 import sahreFromSawbotoOtherIcon from "../map/share_from_sawbo_to_other.png";
 import shareFromSawbotoSawboIcon from "../map/share_from_sawbo_to_sawbo.png";
 import shareThroughOtherAppIcon from "../map/share_through_other_app.png";
 import viewOfflineIcon from "../map/viewOffline.png";
 import viewOnlineIcon from "../map/viewOnline.png";


export default class EventMarker extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      openInfoWindow: false
    };
  };

  handleToggleOpen = () => {
    this.setState({
      openInfoWindow: true
    });
}


  getIcon (eventName) {
    if(eventName==='download_videoid')
    {
      return downloadVideoIcon;
    } else if(eventName==='view_offline')
    {
      return viewOfflineIcon;
    } else if(eventName==='view_online')
    {
      return viewOnlineIcon;
    } else if(eventName==='share_through_other_app')
    {
      return shareThroughOtherAppIcon;
    } else if(eventName==='share_from_sawbo_to_sawbo')
    {
      return shareFromSawbotoSawboIcon;
    } else if(eventName==='share_from_sawbo_to_other')
    {
      return sahreFromSawbotoOtherIcon;
    } else if(eventName==='share_app_bluetooth')
    {
      return shareAppBluetoothIcon;
    } else if(eventName==='receive_shared_video')
    {
      return recieveSharedVidIcon;
    } else if(eventName==='earning_achievement')
    {
      return earningAchivementIcon;
    } else if(eventName==='share_app_through_other')
    {
      return sahreAppThroughOtherIcon;
    }
  };

  getName (eventName) {
    if(eventName==='download_videoid')
    {
      return "Download video";
    } else if(eventName==='view_offline')
    {
      return "View video offline";
    } else if(eventName==='view_online')
    {
      return "View video online";
    } else if(eventName==='share_through_other_app')
    {
      return "Share video through Other app";
    } else if(eventName==='share_from_sawbo_to_sawbo')
    {
      return "Share video from SAWBO app to SAWBO app";
    } else if(eventName==='share_from_sawbo_to_other')
    {
      return "Share video from SAWBO app to another App";
    } else if(eventName==='share_app_bluetooth')
    {
      return "Share App throuhg Bluetooth";
    } else if(eventName==='receive_shared_video')
    {
      return "Recieve shared video";
    } else if(eventName==='earning_achievement')
    {
      return "Earning an achievement";
    } else if(eventName==='share_app_through_other')
    {
      return "Share app through other application";
    }
  };


  render(){
    //console.log(this.props.location);
    return(
        <Marker
          position={this.props.location}
          icon={this.getIcon(this.props.icon)}
          onClick={() => this.handleToggleOpen()} 
        >
                {
            this.state.openInfoWindow &&
         <InfoWindow 
         onCloseClick={() => this.setState({openInfoWindow: false})}>
             <div>
              <span>{this.getName(this.props.icon)}</span>
            </div>
         </InfoWindow>
        }
        </Marker>
    

    );
  }
}